package devxertech.com.pages.dashboard.portFolioSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCaretLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaCaretRight
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonText
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun PortfolioSection() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()
    val images = listOf(
        mapOf("image" to Res.Image.zone360_portfolio, "name" to "ZONE360"),
        mapOf("image" to Res.Image.safe_deposit_portfolio, "name" to "Safe Deposit"),
        mapOf("image" to Res.Image.tcld, "name" to "Touch Land"),
    )
    var startIndex by remember { mutableStateOf(0) }
    val totalImages = images.size
    val itemsPerPage = when {
       window.screen.width > 1360  -> 3
        window.screen.width in 768 .. 1359  -> 2
        else -> 1
    }

    val displayIndex = startIndex / itemsPerPage + 1
    val maxDisplayIndex = (totalImages + itemsPerPage - 1) / itemsPerPage
    val progressPercentage = ((100.0 * displayIndex) / maxDisplayIndex).toFloat().coerceAtMost(100f)
    val imagesShown = minOf(startIndex + itemsPerPage, totalImages)

    val primaryDividerWidth = ((100.0 * displayIndex) / maxDisplayIndex).toInt().coerceAtMost(100)
    val secondaryDividerWidth = (100 - primaryDividerWidth).coerceAtLeast(0)


    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = 50.px, leftRight = 20.px)
            .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            CommonText(
                "Our Portfolio",
                fontSize = if (breakpoint >= Breakpoint.MD) 18.px else 15.px,
                textAlign = TextAlign.Center
            )
            Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                FieldTitleTextNormalSimple("Empowering Journey ",
                    fontSize = if (breakpoint >= Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700
                    )
                FieldTitleTextNormalSimple("Happy Clients ",
                    fontSize = if (breakpoint >= Breakpoint.MD) 35.px else 20.px,
                        color = sitePalette.primary.rgb,
                    fontWeight = 700,
                )
                FieldTitleTextNormalSimple("& Proven Results",
                        fontSize = if (breakpoint >= Breakpoint.MD) 35.px else 20.px,
                        fontWeight = 700
                    )

            }

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(top = if(breakpoint >= Breakpoint.LG) 90.px else 30.px, bottom = 30.px)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().gap(40.px),
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    images.drop(startIndex).take(itemsPerPage).forEach { image ->
                    PortfolioSectionImages(
                        image = image["image"] as String,
                        name = image["name"] as String,
                        breakpoint = breakpoint)
                    }
                }
            }


            Row(
                modifier = Modifier.width(if (breakpoint >= Breakpoint.MD) 627.px else 90.percent),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                FaCaretLeft(
                    modifier = Modifier.color(if(startIndex == 0) Colors.Gray else sitePalette.primary.rgb).cursor(Cursor.Pointer).onClick {
                        startIndex = maxOf(0, startIndex - itemsPerPage)
                    }
                )
                Row(
                    modifier = Modifier.width(if (breakpoint >= Breakpoint.MD) 550.px else 320.percent)
                        .margin(leftRight = 10.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(
                        modifier = Modifier
                            .width(if (breakpoint >= Breakpoint.MD) 550.px else 320.percent)
                            .margin(leftRight = 10.px)
                            .height(3.px)
                            .borderRadius(2.5.px)
                            .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)
                    ) {
                        Box(
                            modifier = Modifier
                                .fillMaxHeight()
                                .width(progressPercentage.percent)
                                .backgroundColor(sitePalette.primary.rgb)
                        )
                    }
                }
                FaCaretRight(
                    modifier = Modifier.color(if(startIndex >= totalImages - itemsPerPage) Colors.Gray else sitePalette.primary.rgb)
                        .cursor(Cursor.Pointer)
                        .onClick {
                        startIndex = minOf(totalImages - itemsPerPage, startIndex + itemsPerPage)
                    }
                )
            }

            CommonText(
                "$imagesShown/$totalImages",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                textAlign = TextAlign.Center,


            )
        }
    }
}

@Composable
fun PortfolioSectionImages(
           breakpoint: Breakpoint,
           image : String,
           name : String) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column (horizontalAlignment = Alignment.CenterHorizontally){
        Image(
            src = image,
            modifier = Modifier
                .width(
                    when{
                        window.screen.width > 1600 -> 470.px
                        window.screen.width > 1400 -> 450.px
                        window.screen.width in 800..1200 -> 440.px
                        window.screen.width in 370..700 -> 320.px
                        else -> 277.px
                    })
//                .width(if (breakpoint > Breakpoint.MD) 440.px
//                else if(breakpoint == Breakpoint.MD) 370.px else 277.px)
                .height(if (breakpoint > Breakpoint.MD) 310.px else 180.px),
        )
        CommonText(name, color = sitePalette.textFieldSupportiveTextColor.rgb,
            fontSize = 20.px,
            fontWeight = 600,
            marginTop = 20.px,
            textAlign = TextAlign.Center,
            marginBottom = if (breakpoint < Breakpoint.MD) (-20).px else 15.px)
    }

}
